import { CoverInfo, CustomImage, ImageDetails } from "burde";
import { CalendarSizeDimensions } from "svg/constants";
import { D3Selection } from "svg/draw/draw-calendar";
import { drawBackPage } from "svg/draw/draw-backside";

const drawSinglePageBackside = (
    base: D3Selection,
    calendarSize: string,
    calendarDimensions: CalendarSizeDimensions,
    backCoverImage: ImageDetails | null,
    coverColor: string | null,
    customBackImage: CustomImage | null,
) => {
    let container = base.append("div").attr("class", "svg-container");

    let svg = container
        .append("svg")
        .attr("width", "100%")
        .attr("height", "100%")
        .attr("preserveAspectRatio", "xMinYMin slice")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true);

    drawBackPage(
        svg,
        calendarSize,
        calendarDimensions,
        backCoverImage,
        coverColor,
        customBackImage,
    );
};

export { drawSinglePageBackside };
